(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eufy-home-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eufy-motion')) {
  customElements.define('eufy-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.pointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.target = this.querySelector('.eufy-hero__image');
      this.reset = () => {
        cancelAnimationFrame(this.frame);
        this.style.setProperty('--eufy-mx', '0px');
        this.style.setProperty('--eufy-my', '0px');
        this.style.setProperty('--eufy-rotate', '0deg');
      };
      this.addEventListener('pointermove', event => {
        if (!this.pointer.matches || this.reduced.matches || !this.target) return;
        const x = event.clientX, y = event.clientY;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const box = this.getBoundingClientRect();
          const px = Math.max(-1, Math.min(1, (x - box.left) / box.width * 2 - 1));
          const py = Math.max(-1, Math.min(1, (y - box.top) / box.height * 2 - 1));
          this.style.setProperty('--eufy-mx', `${px * 14}px`);
          this.style.setProperty('--eufy-my', `${py * 10}px`);
          this.style.setProperty('--eufy-rotate', `${px * 1.2}deg`);
        });
      }, { passive: true, signal: this.abort.signal });
      this.addEventListener('pointerleave', this.reset, { signal: this.abort.signal });
      this.reduced.addEventListener('change', this.reset, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eufy-video-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eufy-story')) {
  customElements.define('eufy-story', class extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) { this.setAttribute('data-visible', ''); this.querySelector('video')?.play().catch(() => {}); }
          else this.querySelector('video')?.pause();
        }
      }, { threshold: 0.15 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
